import Api from "@/services/Api";

export default {
  availableToCharacter(characterId) {
    return Api().get("users/available_to_character/" + characterId);
  }
};
